import React from 'react'
import { StyledTableCell } from '../styles';

const List = ({ list }) =>
  list.map(({ id, label, isLabel }) =>
    !isLabel ? (
      <StyledTableCell align="center" key={id}>
        {label}
      </StyledTableCell>
    ) : (
      <StyledTableCell sx={{ fontWeight: 700 }} align="center">
        {label}
      </StyledTableCell>
    )
  )


export default List;